

export const disbursementValue = {
    "En proceso" : "En proceso: Plazo máximo siguiente día hábil a la firma 7PM",
    "Exitoso": "Exitoso: Tu crédito se desembolsó el ",
    "Fallido": "Fallido: No pudimos desembolsar tu crédito, contáctate con un asesor para ayudarte",
    "Anulado": "Anulado"
}